import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SessionService } from '@core/services/session.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private router: Router,
        private sessionService: SessionService
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.sessionService.authenticatedUser && this.sessionService.authenticatedUser.access_token) {
            // logged in so return true
            return true;
        }

        const lang = localStorage.getItem('LOCALIZE_DEFAULT_LANGUAGE');

        this.router.navigate([`${lang}` + '/auth/login'], { queryParams: { returnUrl: this.getReturnUrl(state) } });
        return false;
    }

    private getReturnUrl(routerState: RouterStateSnapshot): string {
        // not logged in so redirect to login page with the return url
        if (routerState.url && !routerState.url.startsWith('/auth') && routerState.url !== '/') {
            return routerState.url;
        } else {
            return undefined;
        }
    }
}
